import React, { FC, ReactNode } from 'react';
import { map } from 'lodash';
import Button, { ButtonVariant } from '@/components/Common/Button';
import { PropsWithClassName } from '@/types/common';
import * as styles from './Steps.module.scss';

export type Step = {
  title: ReactNode;
  isDisabled: boolean;
};

type Props = PropsWithClassName<{
  steps: Step[];
  activeIndex: number;
  onChange: (index: number) => void;
}>;

const Steps: FC<Props> = ({ steps, activeIndex, onChange }) => (
  <div className={styles.main}>
    {map(steps, ({ title, isDisabled }, index) => (
      <Button
        key={index}
        variant={ButtonVariant.Bare}
        className={styles.step}
        aria-selected={index === activeIndex}
        disabled={isDisabled}
        onClick={() => onChange(index)}
      >
        {title}
      </Button>
    ))}
  </div>
);

export default Steps;
